import { render, staticRenderFns } from "./WidgetView.vue?vue&type=template&id=29139f16&scoped=true&"
import script from "./WidgetView.vue?vue&type=script&lang=js&"
export * from "./WidgetView.vue?vue&type=script&lang=js&"
import style0 from "./WidgetView.vue?vue&type=style&index=0&id=29139f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29139f16",
  null
  
)

export default component.exports